const VALUE = 'value';
const PERCENT = 'percent';
const FORMULA = 'formula';

export default class CalculatedBy {
    static get VALUE() { return VALUE; }
    static get PERCENT() { return PERCENT; }
    static get FORMULA() { return FORMULA; }
}
